/**
 * Переключатель.
 *
 * Вместо галочки, и разница не в моде. Галочка означает «отмечено» — выбор из
 * списка, который вступит в силу, когда нажмут «сохранить». Здесь же каждое
 * переключение — это решение, которое уходит на сервер немедленно и меняет то,
 * что будет скопировано ночью. Переключатель именно это и обещает: положение,
 * а не отметку.
 *
 * Состояние «ждём ответ» показывается самим переключателем: он остаётся в
 * прежнем положении, пока сервер не подтвердит. Двигать его сразу значило бы
 * показать решение, которого ещё нет, — а если запрос упадёт, ползунок
 * прыгнет обратно, и владелец не поймёт, что именно сейчас настроено.
 */
import React from 'react';

export interface ToggleProps {
  checked: boolean;
  disabled?: boolean;
  /** Подпись справа. Кликается вместе с переключателем. */
  label?: React.ReactNode;
  title?: string;
  ariaLabel?: string;
  onChange: (next: boolean) => void;
}

export function Toggle({
  checked, disabled, label, title, ariaLabel, onChange,
}: ToggleProps): React.JSX.Element {
  return (
    <label className={`toggle${disabled ? ' toggle--off' : ''}`} title={title}>
      <input
        type="checkbox"
        className="toggle__input"
        checked={checked}
        disabled={disabled}
        aria-label={ariaLabel}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="toggle__track" aria-hidden="true">
        <span className="toggle__knob" />
      </span>
      {label != null && <span className="toggle__label">{label}</span>}
    </label>
  );
}
